import { Module } from 'vuex';
import { ClipboardState, state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const clipboard: Module<ClipboardState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default clipboard;
